import { render } from "./toGo.vue?vue&type=template&id=1173022a&scoped=true"
import script from "./toGo.vue?vue&type=script&lang=js"
export * from "./toGo.vue?vue&type=script&lang=js"

import "./toGo.vue?vue&type=style&index=0&id=1173022a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1173022a"]])

export default __exports__